<template>
  <v-dialog v-model="is_open" max-width="480">
    <v-card class="manual-send-card">
      <v-card-title class="manual-send-title pt-0 pl-0 pr-0 pb-0">정품 인증 회원 카톡/SMS/메일 발송</v-card-title>
      <v-card-subtitle class="manual-send-subtitle mt-1 pt-0 pl-0 pr-0">
        카톡/SMS/메일 메뉴에서 설정하신 템플릿 내용을 고객에게 발송할 수 있습니다.
      </v-card-subtitle>
      <v-card-text class="manual-send-body pt-0 pl-0 pr-0">
        <div class="field-label">회원 ID</div>
        <v-text-field v-model="member_id" outlined dense readonly disabled hide-details class="manual-input readonly-input"></v-text-field>

        <div class="field-label">이름</div>
        <v-text-field
          v-model="member_name"
          outlined
          dense
          readonly
          disabled
          hide-details
          class="manual-input readonly-input"
        ></v-text-field>

        <div class="field-label">핸드폰</div>
        <v-text-field v-model="member_phone" outlined dense hide-details class="manual-input"></v-text-field>

        <div class="field-label">이메일</div>
        <v-text-field v-model="member_email" outlined dense hide-details class="manual-input"></v-text-field>

        <div class="field-label">템플릿 선택</div>
        <v-select
          v-model="selected_template"
          :items="template_items"
          outlined
          hide-details
          dense
          placeholder="템플릿 명"
          class="manual-input"
        ></v-select>
      </v-card-text>
      <v-card-actions class="manual-send-actions">
        <v-btn class="btn-close" @click="closeModal">닫기</v-btn>
        <v-btn class="btn-send" @click="sendMessage">발송하기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.manual-send-card {
  border-radius: 8px;
  padding: 24px;
}

.manual-send-title {
  font-weight: 700;
  font-size: 20px;
  color: #000;
  padding: 0 0 4px 0;
  line-height: 1.4;
}

.manual-send-subtitle {
  font-size: 14px;
  color: #666;
  padding: 0 0 24px 0;
  line-height: 1.5;
}

.manual-send-body {
  padding: 0;
}

.field-label {
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin-bottom: 8px;
  margin-top: 0;
}

.manual-input {
  margin-bottom: 16px;
}

.manual-input :deep(.v-input__slot) {
  border-radius: 4px;
  min-height: 48px;
}

.manual-send-actions {
  display: flex;
  gap: 10px;
  padding: 8px 0 0 0;
}

.btn-close,
.btn-send {
  flex: 1;
  height: 48px;
  border-radius: 4px;
  text-transform: none;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: -0.3px;
}

.btn-close {
  background: #000 !important;
  color: #fff !important;
}

.btn-send {
  background: #2196f3 !important;
  color: #fff !important;
}
</style>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      is_open: false,
      member_id: "",
      member_name: "",
      member_phone: "",
      member_email: "",
      selected_template: null,
      template_items: ["선택된 템플릿이 없습니다."],
    };
  },
  methods: {
    async open(payload) {
      this.member_id = payload.member_id || "비회원";
      this.member_name = payload.member_name || "";
      this.member_phone = payload.member_phone || "";
      this.member_email = payload.member_email || "";
      this.selected_template = null;
      this.is_open = true;
      await this.loadTemplates();
    },
    closeModal() {
      this.is_open = false;
    },
    async loadTemplates() {
      try {
        const res = await M.api(M.entry("/get/config/message"), { type: "manual" });
        if (res) {
          this.template_items = res
            .filter((item) => item.status === "enabled")
            .map((item) => ({
              text: item.msg_title || item.msg_type,
              value: item.msg_type,
            }));
        }
      } catch (err) {
        console.log("load manual templates error", err);
      }
    },
    async sendMessage() {
      if (!this.member_phone) {
        this.alertShow("핸드폰 번호를 입력해주세요.");
        return;
      }
      if (!this.selected_template) {
        this.alertShow("템플릿을 선택해주세요.");
        return;
      }
      try {
        const payload = {
          msg_type: this.selected_template,
          member_id: this.member_id,
          member_name: this.member_name,
          member_phone: this.member_phone,
          member_email: this.member_email,
        };
        const res = await M.api(M.entry("/post/message/send/manual"), payload);
        if (res) {
          this.alertShow("발송되었습니다.");
          this.closeModal();
        }
      } catch (err) {
        console.log("manual send error", err);
      }
    },
  },
};
</script>
